import InfoItemBottom1Image from 'assets/images/landing/infoItemBottom1.png'
import InfoItemBottom2Image from 'assets/images/landing/infoItemBottom2.png'
import InfoItemBottom3Image from 'assets/images/landing/infoItemBottom3.png'
import FigureItem from 'components/FigureItem'
import styled from 'styled-components'

const infoList = [
  {
    image: InfoItemBottom1Image,
    alt: 'communication',
    title: 'Assistance 5j/7',
    description: 'Un N° dédié pour toutes vos questions',
  },
  {
    image: InfoItemBottom2Image,
    alt: 'paiement',
    title: 'Paiement sécurisé',
    description: 'La sécurité est notre priorité',
  },
  {
    image: InfoItemBottom3Image,
    alt: 'protection',
    title: 'Protection du compte',
    description: 'et de vos données personnelles',
  },
]

const ReassuranceItems = () => (
  <InfoList>
    { infoList.map((info, i) => (
      <FigureItem
        key={ i }
        { ...info }
      />
    ),
    )}
  </InfoList>
)

const InfoList = styled.ul`
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding-left: 0;
  margin-bottom: 3rem;
`

export default ReassuranceItems
